import { Box, Flex, Hide, HStack, Show } from '@chakra-ui/react';
import { ConnectWalletButton } from './ConnectWalletButton';
import { CratLogo } from './CratLogo';
import { CratIcon } from '../CratIcon/CratIcon';
import { LinkList } from './LinkList';
import { HeaderMenuModal } from './HeaderMenuModal';
import React from 'react';

export const Header = React.memo(() => {
  return (
    <Box as="header" py={'16px'} px={{ base: '20px', sm: '40px', md: '77.5px' }} h={'72px'} minW={'100%'}>
      <Flex justifyContent={'space-between'} alignItems={'center'} h={'40px'}>
        <Show above="400px">
          <CratLogo />
        </Show>
        <Hide above="400px">
          <CratIcon w={'35px'} h={'39px'} />
        </Hide>
        <HStack gap={{ base: '20px', lg: '40px' }}>
          <Hide above="840px">
            <HeaderMenuModal />
          </Hide>
          <Show above="840px">
            <LinkList />
          </Show>
          <ConnectWalletButton />
        </HStack>
      </Flex>
    </Box>
  );
});
